import bannerBox from "@/components/letterManage/model/bannerBox";
import singleRowBox from "@/components/letterManage/model/singleRowBox";
import multiRowBox from "@/components/letterManage/model/multiRowBox";
import twoColumnBox from "@/components/letterManage/model/twoColumnBox";
import threeColumnBox from "@/components/letterManage/model/threeColumnBox";
import listBox from "@/components/letterManage/model/listBox";

export default {
  components: {
    bannerBox,
    singleRowBox,
    multiRowBox,
    twoColumnBox,
    threeColumnBox,
    listBox
  },
  data() {
    return {
      field: [{
          field: "titleH1",
          type: "text",
          name: "H1標題"
        },
        {
          field: "titleH2",
          type: "text",
          name: "H2標題"
        },
        {
          field: "contentP",
          type: "text",
          name: "P內容"
        },
        {
          field: "buttonName",
          type: "text",
          name: "按鈕名稱"
        },
        {
          field: "buttonUrl",
          type: "text",
          name: "按鈕連結"
        },
        {
          field: "image",
          type: "text",
          name: "圖片"
        },
        {
          field: "imageShow",
          type: "text",
          name: "使用圖片"
        }
      ],
      bodyModel: [{
          name: "版型1-橫幅",
          values: "banner"
        }, {
          name: "版型2-單列",
          values: "singleRow"
        }, {
          name: "版型3-多列",
          values: "multiRow"
        }, {
          name: "版型4-兩欄式",
          values: "twoColumn"
        },
        //  {
        //   name: "版型5-三欄式",
        //   values: "threeColumn"
        // }, 
        {
          name: "版型6-條列式",
          values: "list"
        }
      ],

      // letterList: {
      //   title: {
      //     title: "",
      //     inname: "",
      //     sendTime: this.$moment().format("YYYY-MM-DD"),
      //     sync: false,
      //   },
      //   header: {
      //     title: "",
      //     image: "",
      //   },
      //   body: [{
      //     model: "",
      //     title: "",
      //     titleSub: "",
      //     dataList: [{
      //       delete: false,
      //       titleH1: "",
      //       titleH2: "",
      //       contentP: "",
      //       buttonName: "",
      //       buttonUrl: "",
      //       image: "",
      //       imageShow: ""
      //     }],
      //     delete: false
      //   }],
      //   footer: {
      //     title: "",
      //     dataList: [],
      //   }
      // },
      defaultBody: {
        model: "",
        title: "",
        titleSub: "",
        dataList: [{
          delete: false,
          titleH1: "",
          titleH2: "",
          contentP: "",
          buttonName: "",
          buttonUrl: "",
          image: "",
          imageShow: ""
        }],
        delete: false
      },

      defaultList: {
        delete: false,
        titleH1: "",
        titleH2: "",
        contentP: "",
        buttonName: "",
        buttonUrl: "",
        image: "",
        imageShow: ""
      },
      defaultFooter: {
        delete: false,
        buttonName: "",
        buttonUrl: ""
      }
    };
  },

  created() {
    this.getEpaper(this.$route.params.uid);
  },

  computed: {
    letterList: {
      get() {
        return this.$store.state.epaper.letterList;
      }
    },
    getDelete() {
      return (list) => {

        let temp = _.filter(list, (item, key) => {
          return !item.delete
        });

        // if (temp.length == 0) {
        //   console.log("delete")
        //   this.createList(temp);
        // }

        return temp;
      }
    },
    getComponent() {
      return (model) => {

        let component = {
          banner: "bannerBox",
          singleRow: "singleRowBox",
          multiRow: "multiRowBox",
          twoColumn: "twoColumnBox",
          threeColumn: "threeColumnBox",
          list: "listBox"
        };

        return component[model] ? component[model] : "";
      }
    },
    checkModel() {
      return (model) => {
        if (model == "banner" || model == "singleRow") {
          return false;
        }
        return true;
      }
    },
    getField() {
      return (model) => {

        let temp = ["titleH1", "titleH2", "contentP", "buttonName", "buttonUrl", "image",
          "imageShow"
        ];

        switch (model) {
          case "banner":
            temp = ["titleH1", "titleH2"];
            break;
          case "singleRow":
            temp = ["titleH1", "contentP", "buttonName", "buttonUrl"];
            break;
          case "multiRow":
          case "twoColumn":
          case "threeColumn":
            temp = ["titleH2", "contentP", "buttonName", "buttonUrl", "imageShow",
              "image"
            ];
            break;
          case "list":
            temp = ["buttonName", "buttonUrl"];
            break;
          default:
            temp = [];
            break;
        }

        let field = _.mapValues(temp, (item) => {
          return _.find(this.field, {
            field: item
          });
        });

        return field;
      }
    }
  },

  methods: {
    getEpaper(uid) {
      this.$store.dispatch("epaper/getEpaper", uid);
    },

    createBody() {
      let temp = JSON.parse(JSON.stringify(this.defaultBody));
      this.letterList.body.push(temp);
    },
    deleteBody(body) {
      body.delete = true;
    },
    createList(list, source = "body") {
      let temp = {};

      if (source == "footer") {
        temp = JSON.parse(JSON.stringify(this.defaultFooter));
      } else {
        temp = JSON.parse(JSON.stringify(this.defaultList));
      }

      list.push(temp);
    },
    deleteList(list) {
      list.delete = true;
    },
    editClick(index) {
      console.log(index);
    },
    previewLetter(){
      let webPath = process.env.VUE_APP_PATH_WEB;
      let letterPath = "/previewLetter/" + this.$route.params.uid;
      window.open(webPath + letterPath);
    },
    submitLetter() {
      this.$store.dispatch("epaper/saveEpaper", this.letterList);
    }
  },
};
